import { env } from '@/shared/config/env';

const backendOrigin = (env.ASSET_BASE_URL ?? new URL(env.API_BASE_URL).origin).replace(/\/$/, '');

/** Build an absolute URL for assets that continue to be served by Laravel. */
export function backendAssetUrl(path: string): string {
  return `${backendOrigin}/${path.replace(/^\//, '')}`;
}
